{/* Auto-generated icon - do not edit */}
import React from 'react'

interface Menu2IconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string
}

export const Menu2Icon = React.forwardRef<SVGSVGElement, Menu2IconProps>(
  ({ size = 24, color = "currentColor", ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 105 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        
<g clip-path="url(#clip0)">
<path d="M50.8763 18.6863C52.0016 18.6845 53.1153 18.4583 54.1524 18.0209C55.1895 17.5834 56.1294 16.9434 56.917 16.1384C57.6685 15.3799 58.2587 14.4767 58.6521 13.4834C59.0456 12.4901 59.2343 11.4273 59.2063 10.359C59.082 6.08141 55.0657 1.98389 50.7801 1.76309C49.9142 1.74871 49.0543 1.9096 48.2519 2.23608C47.4495 2.56255 46.7214 3.04801 46.1108 3.66319C45.1534 4.58877 44.388 5.69473 43.8588 6.91759C43.3297 8.14047 43.047 9.45619 43.0272 10.7888C42.9955 11.8216 43.1704 12.8504 43.5411 13.8147C43.9117 14.779 44.4709 15.6594 45.1858 16.4044C45.9319 17.1436 46.8179 17.7261 47.7916 18.118C48.7655 18.5098 49.8075 18.703 50.8568 18.6863H50.8763Z" fill={color}/>
<path d="M89.9714 13.7806C91.4176 15.0221 93.2693 15.6866 95.1734 15.6472C95.851 15.6456 96.526 15.5745 97.1886 15.435C98.5524 15.1892 99.841 14.6304 100.953 13.8025C102.066 12.9745 102.971 11.8997 103.599 10.6626C104.084 9.64799 104.289 8.52234 104.195 7.4016C104.1 6.28084 103.708 5.20563 103.06 4.28712C101.163 1.28774 96.9401 -0.194179 93.4446 0.912408C89.9289 2.0262 87.4865 5.85831 87.6383 10.0233C87.6422 10.1403 87.6775 10.2543 87.739 10.354C87.8594 10.5466 87.9843 10.7997 88.1256 11.0807C88.5671 12.0884 89.1931 13.0041 89.9714 13.7806Z" fill={color}/>
<path d="M7.59294 18.4293C7.87845 18.4651 8.16592 18.4831 8.45366 18.483C10.1219 18.469 11.7361 17.8886 13.0323 16.8366C13.8843 16.1561 14.5935 15.3133 15.1187 14.357C15.644 13.4006 15.9751 12.3495 16.0929 11.2643C16.535 7.10986 13.7603 3.12839 10.0352 2.56822C9.06523 2.43339 8.07814 2.49744 7.13367 2.75648C6.18917 3.01552 5.30705 3.46418 4.54095 4.07514C3.5978 4.8133 2.81198 5.73321 2.2296 6.78064C1.64722 7.82799 1.28005 8.98175 1.1501 10.1736C1.01707 11.1416 1.07948 12.1265 1.33342 13.07C1.58737 14.0135 2.0277 14.8963 2.6285 15.6662C3.2293 16.4361 3.9782 17.0773 4.83094 17.5519C5.68368 18.0265 6.62296 18.3248 7.59294 18.4293Z" fill={color}/>
</g>
<defs>
<clipPath id="clip0">
<rect width="104" height="19" fill={color} transform="translate(0.777344)"/>
</clipPath>
</defs>

      </svg>
    )
  }
)

Menu2Icon.displayName = 'Menu2Icon'
